/** The second frame runs after a paint opportunity for the rendered grid. */
export const afterReportPaint = (callback: () => void): (() => void) => {
  let secondFrame: number | undefined;
  const firstFrame = requestAnimationFrame(() => {
    secondFrame = requestAnimationFrame(callback);
  });
  return () => {
    cancelAnimationFrame(firstFrame);
    if (secondFrame !== undefined) cancelAnimationFrame(secondFrame);
  };
};
